module.exports = __webpack_public_path__ + "img/emoji_54.a9a6f698.png";